module.exports = __webpack_public_path__ + "img/avisos.b67e2d35.svg";